export default __webpack_public_path__ + "static/Wiereilo-f9d2838f7f880a7919506714e3db0ab1.jpg";